import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { DataService } from './data.service';
import { SettingService } from './setting.service';

@Injectable()
export class JwtResolver implements Resolve<any> {
	constructor(private datas:DataService, private router:Router, private settings:SettingService) {
	}

    async resolve(aRoute: ActivatedRouteSnapshot) {
		console.log('JwtResolver', this.datas.userInfo);
        if (aRoute.queryParams.jwt) {
            this.datas.jwt = aRoute.queryParams.jwt;
            localStorage.setItem('common_jwt', this.datas.jwt);
        } else {
            this.datas.jwt = localStorage.getItem('common_jwt');
        }
        if (this.datas.jwt) {
            try {
            let jwts:string[] = this.datas.jwt.split('.');
            this.datas.jwtObj = JSON.parse(atob(jwts[1]));
            if (!(await this.datas.checkAccountAppAccess())) {
                return this.router.parseUrl('/login');
            }
            await this.settings.loadData();
            } catch (e) {
				return this.router.parseUrl('/login');
            }
        } else {
			this.router.navigate(['login']);
		}

		return true;
    }

}
